import { useCallback, useEffect, useState, createRef } from 'react'
import styled from 'styled-components'
import StarRatings from 'react-star-ratings'
import AudienceRating from 'components/AudienceRating'

const GridItem = ({
  tenant,
  colorMode,
  title,
  short,
  authorrating,
  genre,
  image,
  caption,
  text,
}: {
  tenant?: object
  colorMode?: string
  title?: string
  short?: string
  authorrating?: string
  genre?: string
  image?: string
  caption?: string
  text: string
}) => {
  const [isMobile, setIsMobile] = useState(false)
  const [audienceRateCount, setAudienceRateCount] = useState(0)
  const [tippID, setTippID] = useState('not set')

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  useEffect(() => {
    title && setTippID(title.replace(/[^a-z0-9]/gi, '').toLowerCase())
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Griditem className={isMobile ? 'mobile' : 'desktop'}>
      <h3>{title}</h3>
      <div className='short'>{short}</div>
      <div className='rating'>
        <div className='rating author'>
          <StarRatings
            rating={
              authorrating && authorrating
                ? parseFloat(authorrating.replaceAll(',', '.'))
                : 0
            }
            starRatedColor='#ffe462'
            starEmptyColor={colorMode === 'dark' ? '#555' : '#d9d9d9'}
            starHoverColor='#ffe462'
            svgIconPath='M24 1.175l7.553 14.84L48 18.611 36.22 30.38l2.613 16.444L24 39.26 9.167 46.825 11.78 30.38 0 18.613l16.447-2.598z'
            starDimension='23px'
            starSpacing='3px'
            numberOfStars={5}
            name='author-rating'
          />
          <div className='label'>
            <span>{genre}</span>
          </div>
        </div>
      </div>
      <div className='photo'>
        <img
          src={
            'https://storage.googleapis.com/ta-interaktiv/literatur-tipps/images/' +
            image
          }
          alt='foto'
        />
        {caption && <div className='caption'>Foto: {caption}</div>}
      </div>
      <div className='text' dangerouslySetInnerHTML={{ __html: text }} />
      <AudienceRating
        audienceRateCount={audienceRateCount}
        handleUpdateRatingCount={(votes) => {
          setAudienceRateCount(votes)
        }}
        tippId={tippID}
        colorMode={colorMode}
      />
    </Griditem>
  )
}
const Griditem = styled.div`
  color: var(--text-color);

  h3 {
    border-bottom: 1px solid #d4d4d4;
    padding-bottom: 0.6rem;
    margin-bottom: 1rem;
    font-size: 2.8rem;
    line-height: 4rem;
    @media only screen and (max-width: 600px) {
      font-size: 2.3rem;
      line-height: 3.3rem;
    }
  }
  .short {
    font-size: 1.7rem;
    line-height: 2.8rem;
    @media only screen and (max-width: 600px) {
      font-size: 1.5rem;
      line-height: 2.4rem;
    }
  }
  .rating.author {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 1rem 0 0.5rem;
    .label {
      text-align: right;
      color: var(--brandblue-main);
      font-size: 1.25rem;
      letter-spacing: 0.02rem;
      font-weight: 700;
      padding-right: 0.1rem;
      span {
        padding: 0.25rem 1rem 0.4rem;
        background-color: #e8e8e8;
        border-radius: 0.11111111rem;
      }
    }
  }
  .photo {
    margin-bottom: 1.4rem;
    img {
      width: 100%;
    }
  }
  .caption {
    color: var(--gray-3);
    font-size: 1.4rem;
    line-height: 2rem;
    margin-top: 0.3rem;
    margin-bottom: 0;
  }
  .text {
    font-family: var(--font-serif);
    a:hover,
    a:link,
    a:active,
    a:visited {
      background-image: linear-gradient(90deg, #ffe462, #ffe462);
      background-repeat: repeat-x;
      background-position: bottom;
      background-size: 100% 20%;
      transition: all 0.1s ease-in-out;
      color: var(--text-color);
      background-origin: content-box;
      text-decoration: none;
    }
    a:hover {
      background-size: 100% 100%;
      color: var(--brandblue-main);
    }
  }
  .rating.audience {
    margin-top: 2.4rem;
    text-align: center;
  }
`

export default GridItem
